var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "\\uAD6C\\uC131 \\uC694\\uC18C 103 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 21.84,
    viewBox: "0 0 24 21.84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 456",
    d: "M810.036 1056.622c0 5.116 4.724 10.118 11.406 14.539a.928.928 0 0 0 1.187 0c6.682-4.421 11.406-9.423 11.406-14.539 0-4.131-2.855-7.086-6.682-7.086a6.03 6.03 0 0 0-5.318 3.208 6.015 6.015 0 0 0-5.318-3.208c-3.826-.001-6.681 2.955-6.681 7.086zm.947 0c0-3.625 2.425-6.152 5.722-6.152a5.477 5.477 0 0 1 4.825 3.12c.177.29.316.4.505.4s.316-.114.505-.4a5.477 5.477 0 0 1 4.826-3.12c3.3 0 5.722 2.526 5.722 6.152 0 4.775-4.914 9.714-10.888 13.705a.216.216 0 0 1-.328 0c-5.972-3.992-10.889-8.927-10.889-13.705z",
    transform: "translate(-810.036 -1049.535)",
    style: {
      fill: "#3c3c43"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.605f681395ac77ce708aed7f02a70aec.svg";
export { ForwardRef as ReactComponent };